import styled from 'styled-components';

export const StyledSVG = styled.svg`
  margin: auto;
  display: block;
  shape-rendering: auto;
`;
